<template>
  <div class="basic_wrap moneybag-page">
    <div class="red_top_bg page-top">
      <div class="big_tit">
        {{ $t('moneybag.myWallet') }}
      </div>
    </div>

    <div class="hellotitle">
      {{ $t('c3.well') }} , {{ userName }}
    </div>

    <section class="wallet-card">
      <div
        v-if="vip"
        class="vip-pill"
      >
        {{ vip.name }}
      </div>
      <p class="balance-label">
        {{ $t('sky.jifen') }}
      </p>
      <strong class="balance-value">
        {{ funds }}
      </strong>
    </section>

    <div class="btn_box">
      <button
        type="button"
        class="wallet-btn is-primary"
        @click="$router.push('/cash')"
      >
        {{ $t('moneybag.withdraw') }}
      </button>
    </div>

    <div class="manager_box">
      <div
        class="manager-row"
        @click="$router.push('/addcountUsdt')"
      >
        <div class="manager-main">
          <span class="manager-icon">
            <img src="../images/ban1/link.png">
          </span>
          <span>{{ $t('account.add') }}</span>
        </div>
        <img
          class="manager-arrow"
          src="../images/ban1/right.png"
        >
      </div>
      <div
        class="manager-row"
        @click="$router.push('/funds')"
      >
        <div class="manager-main">
          <span class="manager-icon">
            <img src="../images/ban1/time.png">
          </span>
          <span>{{ $t('moneybag.myWallet') }}</span>
        </div>
        <img
          class="manager-arrow"
          src="../images/ban1/right.png"
        >
      </div>
    </div>
  </div>
</template>

<script>
import Fetch from "../../utils/fetch";

export default {
	name: "Moneybag",
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			data: [],
			vip: null,
			list: {},
			account: 0,
			option: [],
			listShow: false,
			funds: 0,
			frozen: 0,
			mymoney: 0,
			userName: "",
		};
	},
	created() {
		this.$parent.footer("moneybag");
	},
	mounted() {
		Fetch("/user/funds").then(r => {
			this.option.push({
				text: this.$t("moneybag.types"),
				value: 0,
			});

			for (var key in r.data.reason) {
				r.data.reason[key] = this.translateReason(key, r.data.reason[key]);
				this.option.push({
					text: r.data.reason[key],
					value: key,
				});
			}

			this.showError(r.data.list.length);
			this.data = r.data.list;
			this.funds = (1 * r.data.money + 1 * r.data.wx_bankbz).toFixed(2);
			this.mymoney = r.data.mymoney;
			this.frozen = r.data.basemoney;
			this.userName = r.data.username;
			this.listd(1);

			if (r.data && r.data.vip) {
				this.vip = r.data.vip;
			}
		});
	},
	methods: {
		translateReason(key, fallback) {
			switch (key) {
			case "1":
				return this.$t("moneybag.recharge");
			case "2":
				return this.$t("moneybag.withdraw");
			case "3":
				return this.$t("moneybag.give");
			case "4":
				return this.$t("moneybag.signIn");
			case "5":
				return this.$t("moneybag.share");
			case "6":
				return this.$t("moneybag.purchase");
			case "7":
				return this.$t("moneybag.redPacket");
			case "8":
				return this.$t("moneybag.reward");
			case "9":
				return this.$t("moneybag.welfare");
			case "10":
				return this.$t("moneybag.invite");
			case "11":
			case "12":
				return this.$t("moneybag.income");
			default:
				return fallback;
			}
		},
		listd(type) {
			var dataf = this.data || [];

			for (var index = 0; index < dataf.length; index++) {
				if (type === 1) {
					dataf[index].show = 1;
				} else if (type === 2) {
					dataf[index].show = dataf[index].reason_type != 3 && dataf[index].reason_type != 4 ? 1 : 0;
				} else {
					dataf[index].show = dataf[index].reason_type == 3 || dataf[index].reason_type == 4 ? 1 : 0;
				}
			}

			this.data = dataf;
		},
		chooseType(val) {
			if (val == 0) {
				Fetch("/user/funds").then(r => {
					this.data = r.data.list;
					this.showError(r.data.list.length);
				});
			} else {
				Fetch("/user/funds", {
					reason_id: val,
				}).then(r => {
					this.data = r.data.list;
					this.showError(r.data.list.length);
				});
			}
		},
		showError(len) {
			this.listShow = len === 0;
		},
	},
};
</script>

<style lang="less" scoped>
.moneybag-page {
	min-height: 100vh;
	background:
		radial-gradient(circle at 100% 0, rgba(113, 210, 204, 0.16), transparent 30%),
		linear-gradient(180deg, #f4faf9 0%, #eaf5f3 100%);
	color: #123d42;
	padding-bottom: 100px;
	box-sizing: border-box;
}

.page-top {
	height: 50px;
	background: #063942;
	color: #fff;
	border-bottom: 1px solid #075e67;
	box-shadow: 0 4px 12px rgba(7, 59, 67, 0.12);
	box-sizing: border-box;

	.big_tit {
		color: #fff;
	}
}

.hellotitle {
	margin: 22px 20px 0;
	color: #074b53;
	font-size: 16px;
	font-weight: 700;
	line-height: 26px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.wallet-card {
	position: relative;
	min-height: 172px;
	margin: 16px 20px 0;
	padding: 30px 24px;
	overflow: hidden;
	border-radius: 18px;
	border: 1px solid #075e67;
	background: linear-gradient(115deg, #063942 0%, #075a62 58%, #0c8188 100%);
	box-shadow: 0 15px 28px rgba(10, 71, 77, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.16);
	text-align: left;
	box-sizing: border-box;
}

.wallet-card::before,
.wallet-card::after {
	position: absolute;
	border-radius: 50%;
	content: '';
}

.wallet-card::before {
	top: -72px;
	right: -42px;
	width: 220px;
	height: 220px;
	border: 1px solid rgba(191, 231, 227, 0.14);
	box-shadow: 0 0 0 34px rgba(191, 231, 227, 0.05), 0 0 0 68px rgba(191, 231, 227, 0.025);
}

.wallet-card::after {
	right: 36px;
	bottom: 35px;
	width: 70px;
	height: 54px;
	border: 6px solid rgba(168, 231, 225, 0.3);
	border-radius: 7px;
	box-shadow: -25px 25px 0 -20px rgba(168, 231, 225, 0.3);
	box-sizing: border-box;
}

.wallet-card > * {
	position: relative;
	z-index: 1;
}

.vip-pill {
	position: absolute;
	z-index: 1;
	top: 18px;
	right: 18px;
	max-width: 46%;
	padding: 5px 11px;
	border: 1px solid rgba(200, 236, 232, 0.38);
	border-radius: 15px;
	background: rgba(255, 255, 255, 0.12);
	color: #e8fbf9;
	font-size: 12px;
	font-weight: 700;
	line-height: 16px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	box-sizing: border-box;
}

.balance-label {
	color: #c8ece8;
	font-size: 14px;
	line-height: 20px;
	font-weight: 600;
}

.balance-value {
	display: block;
	margin-top: 14px;
	color: #fff;
	font-size: 16px;
	font-weight: 800;
	line-height: 40px;
	letter-spacing: 0.3px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.btn_box {
	margin: 18px 20px 0;
	display: grid;
	grid-template-columns: minmax(0, 1fr);
	gap: 12px;
}

.wallet-btn {
	height: 50px;
	border: 1px solid #0a858c;
	border-radius: 14px;
	background: #f4fbfa;
	color: #08646d;
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.wallet-btn.is-primary {
	background: linear-gradient(135deg, #063942 0%, #0c8188 100%);
	box-shadow: 0 10px 18px rgba(8, 103, 111, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.15);
	color: #fff;
}

.wallet-btn:active {
	transform: translateY(1px);
	filter: brightness(0.95);
}

.manager_box {
	margin: 20px 20px 0;
	overflow: hidden;
	border-radius: 18px;
	border: 1px solid #c7e0dd;
	background: rgba(255, 255, 255, 0.96);
	box-shadow: 0 12px 22px rgba(10, 73, 79, 0.09), inset 0 1px 0 #fff;
}

.manager-row {
	min-height: 66px;
	padding: 0 18px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid #deebea;
	box-sizing: border-box;
	cursor: pointer;
}

.manager-row:last-child {
	border-bottom: 0;
}

.manager-main {
	min-width: 0;
	display: flex;
	align-items: center;
	color: #123d42;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
}

.manager-main span:last-child {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.manager-icon {
	width: 38px;
	height: 38px;
	margin-right: 13px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border: 1px solid #d4e9e6;
	border-radius: 12px;
	background: #e8f5f3;
	flex: 0 0 38px;
}

.manager-icon img {
	width: 20px;
	height: 20px;
	object-fit: contain;
	filter: none;
}

.manager-arrow {
	width: 9px;
	height: 15px;
	margin-left: 12px;
	opacity: 0.52;
	filter: none;
}

.manager-row:active {
	background: #eaf6f4;
}

@media screen and (max-width: 374px) {
	.hellotitle,
	.wallet-card,
	.btn_box,
	.manager_box {
		margin-right: 14px;
		margin-left: 14px;
	}

	.balance-value {
		font-size: 16px;
	}

	.vip-pill {
		max-width: 42%;
	}
}
</style>
